import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { Formik } from "formik";
import authService from "../../services/authService";
import { Checkbox } from "primereact/checkbox";
import { Card } from "@material-ui/core";
import { IconButton, InputAdornment } from "@material-ui/core";
import { CustomTextField } from "../../partials/content/Forms";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import ForgotPassword from "./ForgotPassword";
import DialogLayout from "../../partials/content/DialogLayout";
function LoginForm(props) {
  const location = useLocation();
  const today = DateTime.now().year;
  const { companyProfile, reload, setReload } = useGlobalData();
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
    showPassword: false,
    keepMeSignIn: false,
  });
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "1.5rem",
  });
  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "1.5rem" });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    return () => {
      setLoading(false);
      setLoginData({
        username: "",
        password: "",
        showPassword: false,
      });
    };
  }, [reload]);

  return (
    <React.Fragment>
      <div className="kt-login__body">
        <div className="kt-login__form">
          <Card className="kt-login__card">
            <Formik
              initialValues={loginData}
              enableReinitialize={true}
              validate={(values) => {
                const errors = {};

                if (!values.username) {
                  errors.username = "Username is required";
                }

                if (!values.password) {
                  errors.password = "Password is required";
                }

                return errors;
              }}
              onSubmit={(values, { setStatus, setSubmitting }) => {
                enableLoading();
                authService
                  .login(values.username, values.password, values.keepMeSignIn)
                  .then(({ data: { token, userID, userName, fullName } }) => {
                    disableLoading();
                    setReload(reload + 1);
                    props.login(token, { userID, userName, fullName });
                  })
                  .catch((error) => {
                    disableLoading();
                    setSubmitting(false);
                  });
              }}
            >
              {({
                values,
                status,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form
                  noValidate={true}
                  autoComplete="off"
                  className="kt-form"
                  onSubmit={handleSubmit}
                >
                  <div className="row">
                    {companyProfile.companyProfileLogo &&
                    companyProfile.companyProfileLogo.length > 0 ? (
                      <React.Fragment>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <Typography align="center">
                            <Image
                              src={
                                companyProfile.companyProfileLogo.length === 0
                                  ? null
                                  : companyProfile.companyProfileLogo[0]
                                      .imagePath
                              }
                              style={{
                                maxHeight: "8rem",
                                maxWidth: "20rem",
                              }}
                              alt="Company Profile Logo"
                              fluid
                            />
                          </Typography>
                        </div>
                      </React.Fragment>
                    ) : null}
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="kt-login__title">
                        <h3>Core Platform</h3>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <CustomTextField
                        label="Username"
                        inputType="text"
                        propertyName="username"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        values={values}
                        touched={touched}
                        errors={errors}
                        size="small"
                      />
                      <CustomTextField
                        label="Password"
                        inputType={values.showPassword ? "text" : "password"}
                        propertyName="password"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        values={values}
                        touched={touched}
                        endAdornment={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip
                                title={
                                  values.showPassword
                                    ? "Hide Password"
                                    : "Show Password"
                                }
                              >
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => {
                                    setLoginData({
                                      ...values,
                                      showPassword: !loginData.showPassword,
                                    });
                                  }}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {values.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                        }}
                        errors={errors}
                        size="small"
                      />
                    </div>
                  </div>
                  <div className="kt-login__actions">
                    <div
                      type="button"
                      onClick={() => {
                        setOpenForgotPassword(true);
                      }}
                      className="kt-link kt-login__link-forgot"
                    >
                      Forgot Password
                    </div>
                    <button
                      id="kt_login_signin_submit"
                      type="submit"
                      disabled={isSubmitting}
                      className={`btn btn-brand btn-md btn-pill btn-bold ${clsx(
                        {
                          "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading,
                        }
                      )}`}
                      style={loadingButtonStyle}
                    >
                      <i className="fas fa-sign-in-alt"></i>
                      Sign In
                    </button>
                  </div>
                  {location.pathname === "/auth/login" ? (
                    <div className="kt-login__keepsignin">
                      <div className="p-field-checkbox">
                        <Checkbox
                          icon="pi pi-check-circle"
                          inputId="keepMeSignIn"
                          checked={values.keepMeSignIn}
                          onChange={(e) => {
                            setLoginData({
                              ...values,
                              keepMeSignIn: e.checked,
                            });
                          }}
                        />
                        <label htmlFor="keepMeSignIn">Keep me sign in</label>
                      </div>
                    </div>
                  ) : null}
                </form>
              )}
            </Formik>
          </Card>
          <div className="kt-login__logo">
            <div className="d-flex justify-content-center">
              <img
                src={
                  location.pathname === "/auth/login"
                    ? "../media/logos/logo-login-white.png"
                    : "../media/logos/logo-login.png"
                }
                className="img-fluid"
                alt=""
                style={{
                  maxWidth: "8rem",
                }}
              />
            </div>
          </div>
          <div
            className={`d-flex justify-content-center${
              location.pathname === "/auth/login" ? " text-white" : ""
            }`}
          >
            {today.toString()}&nbsp;&copy;&nbsp;
            <a
              href="http://invifo.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`kt-link text-hover-primary${
                location.pathname === "/auth/login" ? " text-white" : ""
              }`}
            >
              Invifo Enterprise
            </a>
            &nbsp;Core Platform. All Rights Reserved.
          </div>
          <div
            className={`d-flex justify-content-center pb-3${
              location.pathname === "/auth/login" ? " text-white" : ""
            }`}
          >
            {companyProfile.platformVersion}
          </div>
        </div>
      </div>
      <DialogLayout
        open={openForgotPassword}
        title="Reset Password Form"
        onCloseDialog={() => {
          setOpenForgotPassword(false);
        }}
        maxWIdth="sm"
      >
        <ForgotPassword
          onCloseDialog={() => {
            setOpenForgotPassword(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default injectIntl(connect(null, auth.actions)(LoginForm));
